import Vue from 'vue'
import VueRouter from 'vue-router'
const Index = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/Index.vue')
const Chat = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/Chat.vue')
const Order = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/Order.vue')
const Tabbar = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/Tabbar.vue')
const Account = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/Account.vue')
const Book = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/Book.vue')
const NotBook = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/NotBook.vue')
const Procure = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/Procure.vue')
const Rules = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/Rules.vue')
const Code = () => import(/* webpackChunkName:"Index_My_Showkb" */ '../components/Code.vue')
Vue.use(VueRouter)

const routes = [
  {
    path: '/tabbar',
    component: Tabbar,
    redirect: '/index',
    children: [{
      path: '/index',
      name: 'index',
      component: Index,
      meta: {
        // 页面标题title
        keepAlive: true,
        title: '支付订单'
      }
    },
    {
      path: '/notbook',
      name: 'notbook',
      component: NotBook,
      meta: {
        // 页面标题title
        keepAlive: true,
        title: '不抢'
      }
    },

    {
      path: '/account',
      name: 'account',
      component: Account,
      meta: {
        keepAlive: true,
        title: '待改价'
      }
    }
    ]
  },
  {
    path: '/order',
    name: 'order',
    component: Order,
    meta: {
      // 页面标题title
      title: '我的订单'
    }
  },
  {
    path: '/rules',
    name: 'rules',
    component: Rules,
    meta: {
      // 页面标题title
      keepAlive: true,
      title: '报价规则'
    }
  },
  {
    path: '/procure',
    name: 'procure',
    component: Procure,
    meta: {
      // 页面标题title
      title: '采购订单'
    }
  },
  {
    path: '/code',
    name: 'code',
    component: Code,
    meta: {
      // 页面标题title
      title: '支付二维码'
    }
  },
  {
    path: '/book',
    name: 'book',
    component: Book,
    meta: {
      // 页面标题title
      title: '书本'
    }
  },
  {
    path: '/chat',
    name: 'chat',
    component: Chat,
    meta: {
      // 页面标题title
      title: '聊天'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
